"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarFill = void 0;
var StarFill;
(function (StarFill) {
    StarFill["Full"] = "url(#StarGradient)";
    StarFill["Half"] = "url(#HalfStarGradient)";
    StarFill["Empty"] = "none";
})(StarFill = exports.StarFill || (exports.StarFill = {}));
